import axios from "axios";
import { StandardAxiosConfig } from "../common";
import {
	Farm,
	Field,
	Grower,
	HydratedSampleEvent,
	HydratedTargetEvent,
	HydratedZone,
	Lab,
	LabPackage,
	Organization,
} from "../types/agrian";
import { AgrianType } from "../types/dataModels/Company";

export class AgrianAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${import.meta.env.VITE_ROGO_API_URL}/agrian`;
	}

	public async getOrganizations(type: AgrianType): Promise<Organization[]> {
		const url = `${this.baseUrl}/organizations?type=${type}`;
		const response = await axios.get(url, StandardAxiosConfig());
		return response.data as Organization[];
	}

	public async getOrganizationsByIds(ids: string[], type: AgrianType): Promise<Organization[]> {
		const url = `${this.baseUrl}/organizations?type=${type}`;
		const response = await axios.post(url, ids, StandardAxiosConfig());
		return response.data as Organization[];
	}

	public async getGrowers(orgIds: string[], type: AgrianType): Promise<Grower[]> {
		const url = `${this.baseUrl}/growers?type=${type}`;
		const response = await axios.post(url, orgIds, StandardAxiosConfig());
		return response.data as Grower[];
	}

	public async getFarms(growerIds: string[], type: AgrianType): Promise<Farm[]> {
		const url = `${this.baseUrl}/farms?type=${type}`;
		const response = await axios.post(url, growerIds, StandardAxiosConfig());
		return response.data as Farm[];
	}

	public async getFields(farmIds: string[], type: AgrianType): Promise<Field[]> {
		const url = `${this.baseUrl}/fields?type=${type}`;
		const response = await axios.post(url, farmIds, StandardAxiosConfig());
		return response.data as Field[];
	}

	public async getSampleEvents(fieldIds: string[], type: AgrianType): Promise<HydratedSampleEvent[]> {
		const url = `${this.baseUrl}/sample-events?type=${type}`;
		const response = await axios.post(url, fieldIds, StandardAxiosConfig());
		return response.data as HydratedSampleEvent[];
	}

	public async getTargetEvents(fieldIds: string[], type: AgrianType): Promise<HydratedTargetEvent[]> {
		const url = `${this.baseUrl}/target-events?type=${type}`;
		const response = await axios.post(url, fieldIds, StandardAxiosConfig());
		return response.data as HydratedTargetEvent[];
	}

	public async getZones(fieldIds: string[], type: AgrianType): Promise<HydratedZone[]> {
		const url = `${this.baseUrl}/zones?type=${type}`;
		const response = await axios.post(url, fieldIds, StandardAxiosConfig());
		return response.data as HydratedZone[];
	}

	public async getLabs(type: AgrianType): Promise<Lab[]> {
		const url = `${this.baseUrl}/labs?type=${type}`;
		const response = await axios.post(url, undefined, StandardAxiosConfig());
		return response.data as Lab[];
	}

	public async getLabPackages(labIds: string[], type: AgrianType): Promise<LabPackage[]> {
		const url = `${this.baseUrl}/lab-packages?type=${type}`;
		const response = await axios.post(url, labIds, StandardAxiosConfig());
		return response.data as LabPackage[];
	}
}
